import React from 'react';
import styles from './intro.scss';
import Animation from '@/Framework/UI/Pages/Landing/Sections/Animation';

const Intro = () => (
  <div className={ styles.intro }>
    <div className={ styles.introContainer }>
      <h1 className={ styles.introTitle }>
        All of the functionality you need for <br />
        seamless, simple IPO research distribution.
      </h1>
    </div>
    <Animation />
  </div>
);

export default Intro;
